<script lang="ts">
	import { page } from '$app/stores';
	import __ from '$lib/stores/TranslationStore';

	const phone = $page.url.pathname === '/seguros' ? '+351 211 453 336' : '+351 211 453 334';
</script>

<div class="bg-light">
	<div class="container mx-auto max-w-5xl py-16">
		<div class="flex flex-col justify-between gap-12 lg:flex-row lg:gap-32">
			<div class="lg:w-1/2">
				<h3
					class="text-center text-2xl font-semibold leading-8 text-primary lg:text-right lg:text-5xl lg:leading-54"
				>
					{$__('Precisa de ajuda?')}
				</h3>
				<p class="mt-7 text-center text-xl text-dark lg:text-right">
					{$__('Aguardamos a sua chamada!')}
				</p>
			</div>
			<div class="mx-auto min-h-[2px] w-5/6 bg-split lg:w-1" />
			<div
				class="text-center text-3xl leading-9 text-dark lg:w-1/2 lg:text-left lg:text-5xl lg:leading-54"
			>
				<a
					href="tel:{phone}"
					on:click={() => window.gtag('event', 'Click', { event_category: 'Click To Call' })}
				>
					<p class="inline font-light leading-[60px] lg:block">+351</p>
					<p class="inline font-semibold leading-[60px] lg:block">{phone.replace('+351 ', '')}</p>
				</a>
				<p class="mt-2 text-xs text-dark-2 lg:text-lg">
					— {$__('Chamada para rede fixa nacional')}
				</p>
				<p class="mt-2 text-sm lg:text-xl">{$__('Segunda a sexta, das 9h às 19h.')}</p>
			</div>
		</div>
	</div>
</div>
